import { useCallback, useEffect } from 'react';
import { Set as ImmutableSet } from 'immutable';
import { wizardEnabledLanguages } from '../constants/WizardRecommendationConstants';
// @ts-expect-error Could not find a declaration file for module
import { fetchFiltersIfNeeded } from '../actions/FilterActions';
import { useDispatch } from 'react-redux';
import getLang from 'LearningCenterUI/utils/getLang';
import { buildAwardTypeUrlParam, buildCategoryUrlParam, buildLanguageUrlParam, buildToolsUrlParam } from '../utils/UrlParamUtils';
import { RESULTS_URL_FRAGMENT, WIZARD_URL_FRAGMENT } from '../constants/Navigation';
import { UserAttributeKeys, useUserAttribute } from '../features/userAttributes';
import { HUBSPOT_SOFTWARE_INDEX } from '../features/wizard';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useCatalogSearch } from '../features/search';
const useWizard = ({
  selectedCategoryGroup,
  selectedCategory,
  selectedTool,
  selectedToolsGroup,
  isToolsSelected,
  showOnlyCerts
}) => {
  const language = getLang();
  const dispatch = useDispatch();
  const {
    userAttribute: includeEnglishState,
    userAttributesError: includeEnglishStateError,
    userAttributeLoading: includeEnglishStateLoading
  } = useUserAttribute(UserAttributeKeys.PREAPPLIED_FILTER_CHANGED);
  const getSelectedCategories = useCallback(() => {
    return ImmutableSet.of(selectedCategory || selectedCategoryGroup);
  }, [selectedCategory, selectedCategoryGroup]);
  const getSelectedTools = useCallback(() => {
    return ImmutableSet.of(selectedTool || selectedToolsGroup);
  }, [selectedTool, selectedToolsGroup]);
  const getSelectionParams = () => {
    return isToolsSelected ? buildToolsUrlParam(selectedTool || selectedToolsGroup) : buildCategoryUrlParam(selectedCategory || selectedCategoryGroup);
  };
  const loadDataInUsersLanguageOnly = wizardEnabledLanguages.includes(language) && !includeEnglishState;
  const resultsUrl = `${RESULTS_URL_FRAGMENT}?${getSelectionParams()}${buildAwardTypeUrlParam(showOnlyCerts)}${buildLanguageUrlParam(loadDataInUsersLanguageOnly ? language : undefined)}`;
  const selectedFilters = {
    languages: loadDataInUsersLanguageOnly ? [language] : [language, 'en'],
    hubSpotSoftware: isToolsSelected ? getSelectedTools().toJS() : undefined,
    categories: isToolsSelected ? undefined : getSelectedCategories().toJS(),
    skip: includeEnglishStateLoading
  };
  const {
    catalogSearchData = [],
    catalogSearchLoading,
    catalogSearchError
  } = useCatalogSearch(selectedFilters);
  const isRequesting = catalogSearchLoading || includeEnglishStateLoading;
  const error = catalogSearchError || includeEnglishStateError;
  const certifiedResultsOnly = catalogSearchData.filter(item => item.data.certification);
  const resultsToShow = showOnlyCerts ? certifiedResultsOnly : catalogSearchData;
  const topResults = resultsToShow.slice(0, 3);
  let resultsCount = 0;
  const resultsCountAllTypes = catalogSearchData.length;
  const resultsCountCertsOnly = certifiedResultsOnly.length;
  resultsCount = showOnlyCerts ? resultsCountCertsOnly : resultsCountAllTypes;
  useEffect(() => {
    dispatch(fetchFiltersIfNeeded());
  }, [dispatch, getSelectedCategories, getSelectedTools, isToolsSelected]);
  return {
    topResults,
    isRequesting,
    resultsUrl,
    resultsCount,
    resultsCountAllTypes,
    resultsCountCertsOnly,
    error
  };
};
export const useWizardParams = () => {
  const {
    categoryGroup,
    category,
    certsOnly
  } = useParams();
  const isToolsSelected = useLocation().pathname.includes(HUBSPOT_SOFTWARE_INDEX);
  return {
    isToolsSelected,
    categoryGroup,
    category,
    showOnlyCerts: certsOnly === undefined ? undefined : certsOnly === 'true'
  };
};
export const useWizardNavigation = () => {
  const history = useHistory();
  const {
    isToolsSelected,
    categoryGroup,
    category,
    showOnlyCerts
  } = useWizardParams();
  const currentPath = [WIZARD_URL_FRAGMENT, isToolsSelected ? HUBSPOT_SOFTWARE_INDEX : undefined, categoryGroup, category, showOnlyCerts].filter(e => e !== undefined);
  const goForward = option => history.push(Object.assign({}, history.location, {
    pathname: [...currentPath, option].join('/')
  }));
  const goBack = () => history.push(Object.assign({}, history.location, {
    pathname: [...currentPath.slice(0, currentPath.length - 1)].join('/')
  }));
  return {
    goForward,
    goBack
  };
};
export default useWizard;